import { styled, Typography } from '@mui/material';

export const Heading = styled(Typography)(({ theme: { palette } }) => ({
  fontSize: '13px',
  lineHeight: '22px',
  letterSpacing: '1px',
  fontWeight: 700,
  color: palette.text.primary,
  textTransform: 'uppercase',
}));
